import { MultiplePermissions } from '@firebird-web/acl';

export const FORECAST_OVERVIEW_MULTIPLE_PERMISSIONS: MultiplePermissions = [
  ['Summary_Table'],
  ['Load_Forecasts'],
  ['Renewables'],
];
